import {
	celveData,
	saveCelve,
	setAvatar,
	changePhone,
	changePwd,
	changeRemind,
	changeDecrypt,
	moneyData,
	paymentCode,
	checkRecharge,
	tixianInfo,
	tixianData,
	walletData,
	extendUrl,
	extendList,
	goodsFilterData,
	goodsList,
	batOnSale,
	batOffSale,
	productDel,
	productBatDel,
	batProductEdit,
	ddShopList,
	ddShopDel,
	resetResourceState,
	goodsRelativeInfoData,
	goodsConfigData,
	submitRelative,
	similarGoodsData,
	syncProduct,
	alibabaRelativeInfoData,
	alibabaSkuInfoData,
	orderServerList,
	orderServerPurchase,
	orderServerPurchaseCheckout,
	orderServerPurchaseState,
	orderServerFilterData,
	orderServerCancelPurchase,
	orderServerGetOperateInfo,
	orderServerOpAfterSale,
	orderManageList,
	orderManageAddressInfo,
	orderManageShopList,
	editSyncOrderQueue,
	orderManageDetail,
	orderManageFilterData,
	orderManageBatPurchase,
	orderManageBatAbnormal,
	orderManageChangeSku,
	orderManageRemarkInfo,
	orderManageAddRemark,
	orderManageServiceRemarkInfo,
	orderManageAddServiceRemark,
	orderManageReceipt,
	ddShopRefreshDecrypt,
	decryptLog,
	unDecrypt,
	reDecrypt,
	decrypt,
	baseConfig,
	checkPrintRecharge,
	changeAutoPrint,
	editPrintProduct,
	businessRoleIndex,
	businessRoleMenus,
	businessRoleAdd,
	businessRoleUpdate,
	businessRoleDel,
	businessRoleInfo,
	businessRoleExt,
	agentuserIndex,
	agentuserFieldList,
	agentuserAdd,
	agentuserDel,
	agentuserInfo,
	agentuserUpdate,
	agentuserResetPwd,
	agentuserExt,
	pddAccountList,
	pddAccountAdd,
	pddAccountDel,
	pddAccountUpdate,
	pddAccountDefault,
	pddAccountSyncOrder,
	mallCateList,
	productRandomEnums,
	productRandomList,
	productRandomDelete,
	productRandomAdd,
	productRandomUpdate,
	orderManageDeleteProduct,
	orderManageDelPddOrder,
	orderManageRepealPurchase,
	orderManageNeedSyncPddOrder,
	orderManageUpdateOrderAfterSale,
	setPddReturnAddress,
	orderManageCancelDelete,
	refreshReturnAddress,
	updatePddAccount,
	updateOrderProduct,
	setSellerWords,
	messageSubmit,
	messageList,
	shareBillData,
	shareBillUpdateStatus,
	shareBillDel,
	shareBillCheckBind,
	updatePddOrderNo,
	syncDdProductInfo,
	submitPddSkuRelative,
	submitAlibabaSkuRelative,
	orderGetPddSkuInfo,
	orderGetAlibabaSkuInfo,
	mywalletCheckPayState,
	changeWx,
	updateBuyMode,
	vipIndex,
	vipPay,
	vipCheckout,
	vipPayState,
	shopVipIndex,
	shopVipPay,
	shopVipCheckout,
	shopVipPayState,
	orderManageSendGiftOrder,
	orderManageSetNotDealOrder,
	getWorkOrderList,
	getWorkOrderDetail,
	createWorkOrder,
	replyWorkOrder,
	finishWorkOrder,
	mallUpdateProductPddGoodsId,
	setAutoSendGift,
	setAutoRefundReason,
	transferOrderToPdd, getWorkOrderUntreatedTotal, getStatisticData, getStatisticExpressData, getStatisticRanking, getStatisticProductDetailData, getStatisticShopProductRanking, getStatisticProductList, orderManageCheckAliOrderType, checkIsOpenProtocolPay, opDoOrderPay, deliverEnums, batEditDeliveryDay, sendAddAlibabaUrl, setGiftMoney, getGiftMoneyList, deleteGiftMoney, getGoodsInfo, addStockIn, getReadyStockList, addLinkStockIn,bindProductInviteCode
} from "../../../api/main/ucenter.js";
import {userinfoData} from "../../../api/main/login.js";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {

	},
	actions: {
		getUserinfoData(conText, payload){//获取个人信息
			userinfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCelveData(conText, payload){//获取上架策略数据
			celveData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveCelveData(conText, payload){//保存上架策略数据
			saveCelve(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		changeAvatar(conText, payload){//更换头像
			setAvatar(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePhone(conText, payload){//换绑手机号
			changePhone(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangePwd(conText, payload){//更改密码
			changePwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeRemind(conText, payload){//接收公众号提醒
			changeRemind(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeDecrypt(conText, payload){//开启自动解密
			changeDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeAutoPrint(conText, payload){//开启自动打单
			changeAutoPrint(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDecryptLog(conText, payload){//解密日志
			decryptLog(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getMoneyData(conText, payload){//获取钱包金额信息
			moneyData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getPaymentCode(conText, payload){//获取支付二维码
			paymentCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCheckRecharge(conText, payload){//查询充值情况
			checkRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getTixianInfo(conText, payload){//获取提现信息
			tixianInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doTixian(conText, payload){//发起提现
			tixianData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWallteData(conText, payload){//获取钱包记录流水
			walletData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendUrl(conText, payload){//获取推广中心链接
			extendUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getExtendList(conText, payload){//获取推广中心合作列表
			extendList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		//我的抖店
		getDdShopList(conText, payload){//抖店列表
			ddShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDdShopDel(conText, payload){//删除抖店
			ddShopDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opResetResourceState(conText, payload){//重置抖店素材容量不足状态
			resetResourceState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		// 我的商品
		getGoodsFilterData(conText, payload){//获取我的商品筛选数据
			goodsFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGoodsList(conText, payload){//获取我的商品列表
			goodsList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatOnSale(conText, payload){//批量上架商品
			batOnSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatOffSale(conText, payload){//批量下架商品
			batOffSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductDel(conText, payload){//删除商品
			productDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBatDel(conText, payload){//批量删除商品
			productBatDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBatProductEdit(conText, payload){//商品批量改价
			batProductEdit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		/**
		 * 关联商品
		 */
		GetGoodsRelativeInfoData(conText, payload){//获取关联商品信息
			goodsRelativeInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetAlibabaRelativeInfoData(conText, payload){//获取关联1688商品信息
			alibabaRelativeInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetAlibabaSkuInfoData(conText, payload){//获取1688商品sku
			alibabaSkuInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetGoodsConfigData(conText, payload){//获取关联商品信息
			goodsConfigData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitRelative(conText, payload){//关联商品信息
			submitRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getSimilarGoodsData(conText, payload){//搜索同款商品
			similarGoodsData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSyncProduct(conText, payload){//一键同步商品
			syncProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderServerList(conText, payload){//线下订单列表
			orderServerList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderServerPurchase(conText, payload){//线下订单采购
			orderServerPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderServerPurchaseCheckout(conText, payload){//线下订单采购支付
			orderServerPurchaseCheckout(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderServerPurchaseState(conText, payload){//线下订单采购支付状态
			orderServerPurchaseState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderServerFilterData(conText, payload){
			orderServerFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderServerCancelPurchase(conText, payload){
			orderServerCancelPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderServerGetOperateInfo(conText, payload){
			orderServerGetOperateInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderServerOpAfterSale(conText, payload){
			orderServerOpAfterSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		opTransferOrderToPdd(conText, payload){
			transferOrderToPdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageAddressInfo(conText, payload){//查看收货人信息
			orderManageAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getOrderManageList(conText, payload){//订单列表
			orderManageList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageShopList(conText, payload){//查看所有店铺
			orderManageShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postEditSyncOrderQueue(conText, payload){//编辑提交同步历史订单
			editSyncOrderQueue(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageDetail(conText, payload){//订单详情
			orderManageDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageFilterData(conText, payload){//订单筛选数据
			orderManageFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatPurchase(conText, payload){//手动批量采购
			orderManageBatPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageCheckAliOrderType(conText, payload){//手动批量采购
			orderManageCheckAliOrderType(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatAbnormal(conText, payload){//批量标记异常
			orderManageBatAbnormal(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doOrderManageChangeSku(conText, payload){//关联商品
			orderManageChangeSku(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageRemarkInfo(conText, payload){//订单标记备注信息
			orderManageRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddRemark(conText, payload){//添加备注和旗子
			orderManageAddRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageServiceRemarkInfo(conText, payload){//订单客服备注信息
			orderManageServiceRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageDeleteProduct(conText, payload){//添加客服备注
			orderManageDeleteProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddServiceRemark(conText, payload){//添加客服备注
			orderManageAddServiceRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opRefreshReturnAddress(conText, payload){
			refreshReturnAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageReceipt(conText, payload){//确认收货
			orderManageReceipt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageSendGiftOrder(conText, payload){//发送礼品单
			orderManageSendGiftOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageSetNotDealOrder(conText, payload){//设置完结订单
			orderManageSetNotDealOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageDelPddOrder(conText, payload){//删除订单
			orderManageDelPddOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageCancelDelete(conText, payload){//删除订单
			orderManageCancelDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageRepealPurchase(conText, payload){//重新采购
			orderManageRepealPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageNeedSyncPddOrder(conText, payload){//同步PDD订单
			orderManageNeedSyncPddOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageUpdateOrderAfterSale(conText, payload){//同步抖店
			orderManageUpdateOrderAfterSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDdShopRefreshDecrypt(conText, payload){//提额成功更新店铺状态
			ddShopRefreshDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUnDecrypt(conText, payload){//放弃解密
			unDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opReDecrypt(conText, payload){//恢复解密
			reDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDecrypt(conText, payload){//解密单个订单
			decrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBaseConfig(conText, payload){//基础设置
			baseConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCheckPrintRecharge(conText, payload){//查询充值打单情况
			checkPrintRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditPrintProduct(conText, payload){//编辑打单商品配置
			editPrintProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleIndex(conText, payload){//岗位管理列表
			businessRoleIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleMenus(conText, payload){//权限系统获取菜单
			businessRoleMenus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleAdd(conText, payload){//添加岗位
			businessRoleAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleUpdate(conText, payload){//更新岗位设置
			businessRoleUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleDel(conText, payload){//删除岗位
			businessRoleDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetSellerWords(conText, payload){
			setSellerWords(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdatePddAccount(conText, payload){
			updatePddAccount(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdatePddOrderNo(conText, payload){
			updatePddOrderNo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateOrderProduct(conText, payload){
			updateOrderProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateBuyMode(conText, payload){
			updateBuyMode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBusinessRoleInfo(conText, payload){//岗位信息
			businessRoleInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessRoleExt(conText, payload){//岗位禁用状态
			businessRoleExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserIndex(conText, payload){//员工列表
			agentuserIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserFieldList(conText, payload){//获取岗位信息
			agentuserFieldList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserAdd(conText, payload){//添加员工
			agentuserAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserDel(conText, payload){//删除员工
			agentuserDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAgentuserInfo(conText, payload){//查询员工修改信息
			agentuserInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserUpdate(conText, payload){//更新员工
			agentuserUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserResetPwd(conText, payload){//重置密码
			agentuserResetPwd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opAgentuserExt(conText, payload){//修改员工显示状态
			agentuserExt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountList(conText, payload){//获取多多账号列表
			pddAccountList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCheckIsOpenProtocolPay(conText, payload){//查询是否开通免密支付
			checkIsOpenProtocolPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountAdd(conText, payload){//新增多多账号
			pddAccountAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountDel(conText, payload){//删除多多账号
			pddAccountDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountUpdate(conText, payload){//更新多多账号
			pddAccountUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountDefault(conText, payload){//设置多多默认账号
			pddAccountDefault(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountSyncOrder(conText, payload){
			pddAccountSyncOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opMallCateList(conText, payload){
			mallCateList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		opProductRandomEnums(conText, payload){
			productRandomEnums(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductRandomList(conText, payload){
			productRandomList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductRandomDelete(conText, payload){
			productRandomDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductRandomAdd(conText, payload){
			productRandomAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductRandomUpdate(conText, payload){
			productRandomUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opMessageSubmit(conText, payload){
			messageSubmit(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getMessageList(conText, payload){
			messageList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		//共享面单
		uShareBillData(conText, payload){
			shareBillData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		uShareBillUpdateStatus(conText, payload){
			shareBillUpdateStatus(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		uShareBillDel(conText, payload){
			shareBillDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		uShareBillCheckBind(conText, payload){
			shareBillCheckBind(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSyncDdProductInfo(conText, payload){
			syncDdProductInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitPddSkuRelative(conText, payload){
			submitPddSkuRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitAlibabaSkuRelative(conText, payload){
			submitAlibabaSkuRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doOrderGetPddSkuInfo(conText, payload){
			orderGetPddSkuInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getMywalletCheckPayState(conText, payload){
			mywalletCheckPayState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doChangeWx(conText, payload){//换绑微信
			changeWx(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getVipIndex(conText, payload){//会员列表
			vipIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opVipPay(conText, payload){//支付会员
			vipPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opVipCheckout(conText, payload){//结算
			vipCheckout(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getVipPayState(conText, payload){//查询支付结果
			vipPayState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetPddReturnAddress(conText, payload){//检查扫码支付状态
			setPddReturnAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopVipIndex(conText, payload){//抖店会员列表
			shopVipIndex(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopVipPay(conText, payload){//抖店支付会员
			shopVipPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopVipCheckout(conText, payload){//抖店结算
			shopVipCheckout(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopVipPayState(conText, payload){//抖店查询支付结果
			shopVipPayState(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWorkOrderList(conText, payload){
			getWorkOrderList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWorkOrderDetail(conText, payload){
			getWorkOrderDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWorkOrderUntreatedTotal(conText, payload){
			getWorkOrderUntreatedTotal(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCreateWorkOrder(conText, payload){
			createWorkOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opReplyWorkOrder(conText, payload){
			replyWorkOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opFinishWorkOrder(conText, payload){
			finishWorkOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opMallUpdateProductPddGoodsId(conText, payload){
			mallUpdateProductPddGoodsId(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetAutoSendGift(conText, payload){//检查扫码支付状态
			setAutoSendGift(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetAutoRefundReason(conText, payload){//更新商家自动退款原因配置
			setAutoRefundReason(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDoOrderPay(conText, payload){//采购订单支付
			opDoOrderPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticData(conText, payload){
			getStatisticData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticRanking(conText, payload){
			getStatisticRanking(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticExpressData(conText, payload){
			getStatisticExpressData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticProductDetailData(conText, payload){
			getStatisticProductDetailData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticShopProductRanking(conText, payload){
			getStatisticShopProductRanking(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticProductList(conText, payload){
			getStatisticProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getDeliverEnums(conText, payload){
			deliverEnums(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postBatEditDeliveryDay(conText, payload){
			batEditDeliveryDay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		sendAddAlibabaUrl(conText, payload){
			sendAddAlibabaUrl(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		setGiftMoney(conText, payload){
			setGiftMoney(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGiftMoneyList(conText, payload){
			getGiftMoneyList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		deleteGiftMoney(conText, payload){
			deleteGiftMoney(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getGoodsInfo(conText, payload){
			getGoodsInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		addStockIn(conText, payload){
			addStockIn(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		addLinkStockIn(conText, payload){
			addLinkStockIn(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getReadyStockList(conText, payload){
			getReadyStockList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBindProductInviteCode(conText, payload){
			bindProductInviteCode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
	}
}
export default modules;
